import React from 'react';
import VideoGallery from './VideoGallery';

const VideoEmbedGallery = ({
  videos,
  videoWidth,
  videoHeight,
  numOfColumns,
}) => {
  const urlProperty = 'url';
  const titleProperty = 'name';
  const imageWidth = 200;
  const imageAspectRatio = '16/9';

  const isItemSelected = (imageId) => {
    return false;
    // if (!value) {
    //   return false;
    // }

    // if (
    //   (!multiple && compareIdentifiers(value.id, imageId)) ||
    //   (multiple &&
    //     value.length &&
    //     value.some((image) => compareIdentifiers(image.id, imageId)))
    // ) {
    //   return true;
    // }
  };

  const handleImageClick = (event) => {
    const clickedItemId = event.currentTarget.dataset.id;
    // let nextValue;

    // if (multiple) {
    //   nextValue = cloneDeep(value) || [];

    //   if (
    //     nextValue.some((image) => compareIdentifiers(image.id, clickedItemId))
    //   ) {
    //     nextValue = nextValue.filter(
    //       (image) => !compareIdentifiers(image.id, clickedItemId)
    //     );
    //   } else {
    //     nextValue.push(clickedItemId);
    //   }
    // } else {
    //   if (value && compareIdentifiers(value.id, clickedItemId)) {
    //     nextValue = null;
    //   } else {
    //     nextValue = images.find((image) =>
    //       compareIdentifiers(image.id, clickedItemId)
    //     );
    //   }
    // }

    // onChange(nextValue);
  };

  const renderImages = (images) => {
    if (!images || !images.length) {
      return <p>No images to pick</p>;
    }

    return images.map((image) => (
      <div
        data-id={image.id}
        onClick={handleImageClick}
        className={`image-picker-item ${
          isItemSelected(image.id) ? 'image-picker-item-selected' : ''
        }`}
        key={image.id}
      >
        <div
          className="image-picker-image"
          style={{ backgroundImage: `url(${image[urlProperty]}` }}
        />
        {typeof renderItemActions === 'function' && (
          <div className="image-picker-actions">{renderItemActions(image)}</div>
        )}
        <div className="image-picker-details">
          <div className="file-title">{image[titleProperty]}</div>
        </div>
      </div>
    ));
  };

  return (
    <VideoGallery
      videos={videos}
      videoWidth={videoWidth ?? 200}
      videoHeight={videoHeight}
      numOfColumns={numOfColumns}
    />
  );
};

export default VideoEmbedGallery;
